<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>
          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Lista para crear y editar cada socio específico.
                Registra datos, contactos, direcciones
                (entrega/factura), roles (quién pide, paga y recibe)
                y compañías/canales donde compra. Úsalo antes de
                vender para evitar errores en entrega y facturación.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Socios de Negocio
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Activa/inactiva, crea, actualiza y elimina los <b>socios de negocio</b> que operan dentro de AVE.
        </div>
      </div>
      <!-- Header -->
      <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
          <app-status-filters [selectedStatuses]="selectedStatuses" [selectedCustomerType]="selectedCustomerType"
            [showCustomerType]="['BPT9002','BPT9001','BPT0001','BPT0004','BPT0002','BPT0003']" [showStatus]="[1,0]"
            [typeFilter]="'master'" (selectionFilterApply)="findAllWithCount()">
          </app-status-filters>
          <!-- <mat-button-toggle-group #toggleGroup="matButtonToggleGroup" class="compact-toggle-group">
            <mat-button-toggle class="compact-toggle h-8 min-h-8 rounded-full px-3" (click)="toggleValue()">
              <span class="text-xs font-medium state-label">
                {{ isActive === 1 ? 'ACTIVO' : 'INACTIVO' }}
              </span>
            </mat-button-toggle>
          </mat-button-toggle-group> -->
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <button class="ml-3 hidden sm:inline-flex" mat-flat-button [color]="'primary'"
            (click)="onExportButtonPressed()" matTooltip="Exportar">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
            <span class="ml-2">Exportar</span>
          </button>

          <button mat-icon-button color="primary" [matMenuTriggerFor]="filterMenu" matTooltip="Glosario">
            <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
          </button>
          <mat-menu #filterMenu="matMenu" class="maxWidth">
            <mat-radio-group [(ngModel)]="geolocationFilter" (change)="filterByGeolocation(geolocationFilter)">
              <button mat-menu-item>
                <div class="menu-item-content">
                  <mat-radio-button value="not_registered" color="primary">
                    <div class="flex items-center">
                      <mat-icon color="warn">location_on</mat-icon>
                      <span>Ubicación no registrada</span>
                    </div>
                  </mat-radio-button>
                </div>
              </button>
              <button mat-menu-item>
                <div class="menu-item-content">
                  <mat-radio-button value="valid" color="primary">
                    <div class="flex items-center">
                      <mat-icon color="primary">location_on</mat-icon>
                      <span>Ubicación válida</span>
                    </div>
                  </mat-radio-button>
                </div>
              </button>
              <button mat-menu-item>
                <div class="menu-item-content">
                  <mat-radio-button value="both" color="primary">
                    <div class="flex items-center">
                      <mat-icon>location_on</mat-icon>
                      <span>Ambos</span>
                    </div>
                  </mat-radio-button>
                </div>
              </button>
            </mat-radio-group>
          </mat-menu>

          <!-- Add button (only icon) -->
          <button mat-icon-button color="primary" (click)="openCreateModal()"
            [matTooltip]="'GENERAL.CREATE' | transloco">
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          </button>
          <div style="display:inline-flex">
            <button mat-icon-button [matMenuTriggerFor]="importMenu" matTooltip="Importar archivo">
              <mat-icon>
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0,0,256,256">
                  <g fill="#4f46e5" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                    stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                    font-family="none" font-weight="none" font-size="none" text-anchor="none"
                    style="mix-blend-mode: normal">
                    <g transform="scale(5.12,5.12)">
                      <path
                        d="M30,26v9h-4.18c0.12,-0.38 0.18,-0.78 0.18,-1.2v-7.8zM30,37v9h-13c-1.65,0 -3,-1.35 -3,-3v-5h7.8c1.03,0 1.98,-0.37 2.71,-1zM32,26h16v9h-16zM32,37h16v6c0,1.65 -1.35,3 -3,3h-13zM30,15v9h-4v-7.8c0,-0.42 -0.06,-0.82 -0.18,-1.2zM32,15h16v9h-16zM30,4v9h-5.49c-0.73,-0.63 -1.68,-1 -2.71,-1h-7.8v-5c0,-1.65 1.35,-3 3,-3zM48,7v6h-16v-9h13c1.65,0 3,1.35 3,3zM21.8,36h-17.6c-1.215,0 -2.2,-0.985 -2.2,-2.2v-17.6c0,-1.215 0.985,-2.2 2.2,-2.2h17.6c1.215,0 2.2,0.985 2.2,2.2v17.6c0,1.215 -0.985,2.2 -2.2,2.2zM7.968,19l3.494,5.978l-3.831,6.022h2.863l2.521,-4.716l2.533,4.716h2.821l-3.769,-6l3.685,-6h-2.675l-2.455,4.505l-2.323,-4.505z">
                      </path>
                    </g>
                  </g>
                </svg>
              </mat-icon>
            </button>
            <mat-menu #importMenu="matMenu">
              <button mat-menu-item [matMenuTriggerFor]="clienteTerritorioMenu">
                <span>Cliente-Territorio</span>
              </button>
              <button mat-menu-item [matMenuTriggerFor]="clienteFrecuenciaMenu">
                <span>Cliente-Frecuencia-Ruta</span>
              </button>
              <button mat-menu-item [matMenuTriggerFor]="adddressMenu">
                <span>Direcciones</span>
              </button>
            </mat-menu>
            <mat-menu #clienteTerritorioMenu="matMenu">
              <button mat-menu-item (click)="openExportDialogRoutes()">
                <mat-icon svgIcon="heroicons_outline:arrow-down-tray"></mat-icon>
                <span>Descargar Plantilla</span>
              </button>
              <button mat-menu-item (click)="openClienteTerritorioImportDialog()">
                <mat-icon svgIcon="heroicons_outline:arrow-up-tray"></mat-icon>
                <span>Importar Archivo Excel</span>
              </button>
            </mat-menu>
            <mat-menu #clienteFrecuenciaMenu="matMenu">
              <button mat-menu-item (click)="downloadClienteFrecuenciaTemplate()">
                <mat-icon svgIcon="heroicons_outline:arrow-down-tray"></mat-icon>
                <span>Descargar Plantilla</span>
              </button>
              <button mat-menu-item (click)="openClienteFrecuenciaImportDialog()">
                <mat-icon svgIcon="heroicons_outline:arrow-up-tray"></mat-icon>
                <span>Importar Archivo Excel</span>
              </button>
            </mat-menu>
            <mat-menu #adddressMenu="matMenu">
              <button mat-menu-item (click)="openExportDialog()">
                <mat-icon svgIcon="heroicons_outline:arrow-down-tray"></mat-icon>
                <span>Descargar Plantilla</span>
              </button>
              <button mat-menu-item (click)="openBusinessPartnerDireccionesImportDialog()">
                <mat-icon svgIcon="heroicons_outline:arrow-up-tray"></mat-icon>
                <span>Importar Archivo Excel</span>
              </button>
            </mat-menu>
            <input #hiddenfileinput style="display: none" type="file" (change)="handleFileInput($event)" accept=".xlsx">
            <button mat-raised-button style="margin-right: 8px;" type="button" *ngIf="aux_file"
              [disabled]="this.fileToUpload.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
              color="primary" (click)="onConfirmImportFile(hiddenfileinput)">
              Importar archivo
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort [trackBy]="trackByFn">
              <!-- Código -->
              <!-- <ng-container matColumnDef="code">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="pl-10 text-left">Código</th>
                  <td mat-cell *matCellDef="let businessPartner" class="pl-10 text-left">{{ businessPartner.code }}</td>
                </ng-container> -->

              <!-- Ubicación -->
              <ng-container matColumnDef="addresses">
                <th mat-header-cell *matHeaderCellDef class="text-left no-padding-cell"></th>
                <td mat-cell *matCellDef="let row" class="text-center no-padding-cell">
                  <mat-icon
                    [color]="(row.addresses?.[0]?.geolocationPoint?.[0] === 0 && row.addresses?.[0]?.geolocationPoint?.[1] === 0) || 
                      !row.addresses?.[0]?.geolocationPoint || row.addresses?.[0]?.geolocationPoint.length == 0 ? 'warn' : 'primary'"
                    (click)="row.addresses?.[0]?.geolocationPoint && row.addresses?.[0]?.geolocationPoint.length > 0 ? openModal(row): null"
                    style="cursor: pointer;">location_on</mat-icon>
                  <!--{{ row.addresses?.[0]?.geolocationPoint?.[0]}}, {{ row.addresses?.[0]?.geolocationPoint?.[1]}}-->
                </td>
              </ng-container>
              <!-- Nombre -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'BUSINESS_PARTNER.NAME' | transloco }}
                </th>
                <td mat-cell *matCellDef="let businessPartner" class="text-sm uppercase leading-tight">

                  <div *ngIf="businessPartner.externalKeys">
                    <div *ngIf="getCode(businessPartner) as code">
                      <b class="f-10">{{ code }}</b>
                    </div>
                  </div>
                  {{ businessPartner.name }}
                </td>
              </ng-container>

              <!-- Tipo -->
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{'BUSINESS_PARTNER.TYPE' | transloco }}
                </th>
                <td mat-cell *matCellDef="let businessPartner" class="text-sm uppercase">
                  {{ businessPartner.types[0]?.name || "No asignada" }}
                </td>
              </ng-container>

              <!-- Compañía -->
              <ng-container matColumnDef="company">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Compañía
                </th>
                <td mat-cell *matCellDef="let businessPartner" class="text-sm uppercase leading-tight">
                  <div>
                    <b>{{ businessPartner.company.code }}</b>
                  </div>
                  <div>{{ businessPartner.company.name }}</div>
                </td>
              </ng-container>

              <!-- División -->
              <ng-container matColumnDef="division">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">
                  División
                </th>
                <td mat-cell *matCellDef="let businessPartner" class="px-6 text-left text-uppercase">
                  <div>
                    <b>{{ businessPartner.division.code }}</b>
                  </div>
                  <div>{{ businessPartner.division.name }}</div>
                </td>
              </ng-container>

              <!-- Credit Limit -->
              <ng-container matColumnDef="creditLimit">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6  text-right">
                  {{ 'BUSINESS_PARTNER.CREDIT_LIMIT' | transloco }} {{ 'code' | companyCurrency: true }}
                </th>
                <td mat-cell *matCellDef="let businessPartner" class="px-6 text text-left text-uppercase">
                  {{ businessPartner.creditLimit | moneda }}
                </td>
              </ng-container>

              <!-- Posición -->
              <!-- <ng-container matColumnDef="position">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="px-6 text-left"
                >
                  Posición
                </th>
                <td
                  mat-cell
                  *matCellDef="let businessPartner"
                  class="px-6 text-left"
                >
                  {{ businessPartner.position }}
                </td>
              </ng-container> -->

              <!-- Estado (mat-slide-toggle) -->
              <ng-container matColumnDef="statusId">
                <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                  {{'BUSINESS_PARTNER.STATUS' | transloco}}
                </th>
                <td mat-cell *matCellDef="let businessPartner" class="px-6 text-left">
                  <mat-slide-toggle [checked]="businessPartner.statusId === 1"
                    (change)="onStatusChange($event.checked, businessPartner)" color="primary">
                  </mat-slide-toggle>
                </td>
              </ng-container>

              <!-- Acciones -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                <td mat-cell *matCellDef="let businessPartner" class="px-6 py-3 text-left">
                  <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionMenu="matMenu">
                    <button mat-menu-item (click)="openEditModal(businessPartner)">
                      <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      <span>{{'GENERAL.EDIT' | transloco }}</span>
                    </button>
                    <button *ngIf="isAllow(businessPartner)" mat-menu-item (click)="openSettingUser(businessPartner)">
                      <mat-icon svgIcon="heroicons_outline:user-circle"></mat-icon>
                      <span>Conf. Usuario</span>
                    </button>
                    <button mat-menu-item (click)="openPriceList(businessPartner)">
                      <mat-icon svgIcon="heroicons_outline:currency-dollar"></mat-icon>
                      <span>Listas de Precios</span>
                    </button>
                    <button mat-menu-item (click)="openBPschedule(businessPartner)">
                      <mat-icon svgIcon="heroicons_outline:calendar-days"></mat-icon>
                      <span>Horarios de Entrega</span>
                    </button>
                    <button mat-menu-item (click)="openDeleteDialog(businessPartner)">
                      <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      <span>{{'GENERAL.DELETE' | transloco }}</span>
                    </button>
                    <button mat-menu-item
                      *ngIf="businessPartner.types[0]?.name === 'ENTREGADOR' || businessPartner.types[0]?.name === 'VENDEDOR'"
                      (click)="openRoutesModal(businessPartner)">
                      <mat-icon svgIcon="heroicons_outline:map-pin"></mat-icon>
                      <span>Rutas asociadas</span>
                    </button>
                    <button mat-menu-item
                      *ngIf="businessPartner.types[0]?.name === 'ENTREGADOR' || businessPartner.types[0]?.name === 'VENDEDOR'"
                      (click)="openTripsModal(businessPartner)">
                      <mat-icon svgIcon="heroicons_outline:map"></mat-icon>
                      <span>Viajes asociados</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"
                class="sticky top-0 z-10 bg-white dark:bg-gray-900">
              </tr>

              <!-- Fila principal -->
              <tr mat-row *matRowDef="let row; columns: displayedColumns" class="border-b h-16"></tr>
            </table>
          </div>
        </div>

        <!-- Paginación -->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
            [pageSize]="pageSize" (page)="onPageChange($event)">
          </mat-paginator>
        </div>
      </div>

      <!-- Modales -->
      <ng-template #addModal>
        <h2 mat-dialog-title class="text-lg font-bold mb-1">{{'GENERAL.CREATE' | transloco}}</h2>
        <mat-dialog-content class="modal-content">
          <mat-tab-group>
            <mat-tab label="Datos Generales">
              <form #createForm="ngForm" class="grid grid-cols-2 gap-4">
                <mat-form-field appearance="fill" class="col-span-1">
                  <mat-label>Código Externo</mat-label>
                  <input matInput [(ngModel)]="currentCreateBusinessPartner.code" name="code" required />
                </mat-form-field>
                <mat-form-field appearance="fill" class="col-span-1">
                  <mat-label>{{'BUSINESS_PARTNER.NAME' | transloco}}</mat-label>
                  <input matInput [(ngModel)]="currentCreateBusinessPartner.name" name="name" required />
                </mat-form-field>

                <mat-form-field appearance="fill" class="col-span-1">
                  <mat-label>Nombre Comercial</mat-label>
                  <input matInput [(ngModel)]="currentCreateBusinessPartner.commercialName" name="commercialName" />
                </mat-form-field>


                <mat-form-field appearance="fill" class="col-span-1">
                  <mat-label>RTN</mat-label>
                  <input matInput [(ngModel)]="currentCreateBusinessPartner.NIT" name="NIT" [required]="isRtnRequired" />
                </mat-form-field>

                <mat-form-field appearance="fill" class="col-span-1">
                  <mat-label>DNI</mat-label>
                  <input matInput [(ngModel)]="currentCreateBusinessPartner.DNI" name="DNI" />
                </mat-form-field>


                <mat-form-field appearance="fill" class="col-span-1">
                  <mat-label for="group-select">{{'BUSINESS_PARTNER.COMPANIES' | transloco}}</mat-label>
                  <mat-select [formControl]="companyMultiCtrl" placeholder="Seleccione una compañía" [multiple]="true">
                    <mat-option>
                      <ngx-mat-select-search [showToggleAllCheckbox]="true"
                        [toggleAllCheckboxIndeterminate]="isIndeterminateComp"
                        [toggleAllCheckboxChecked]="isCheckedComp" (toggleAll)="toggleSelectAllCompany($event)"
                        [formControl]="companyMultiFilterCtrl" [noEntriesFoundLabel]="'No se encontraron resultados'"
                        [clearSearchLabel]="'Limpiar búsqueda'"
                        [placeholderLabel]="'Buscar compañía...'"></ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let company of filteredCompany | async" [value]="company">
                      <b *ngIf="getCode(company) as code">
                        {{ code }} -
                      </b>
                      {{ company.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="
                  companyMultiCtrl.hasError('required') &&
                  (companyMultiCtrl.dirty || companyMultiCtrl.touched)">
                    Seleccione una compañía
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" class="col-span-1">
                  <mat-label for="group-select">{{'BUSINESS_PARTNER.BPTYPE' | transloco}}</mat-label>
                  <mat-select [formControl]="typeMultiCtrl" placeholder="Seleccione tipos de socios de negocio"
                    [multiple]="true" (selectionChange)="onTypeChange($event)">
                    <mat-option>
                      <ngx-mat-select-search [showToggleAllCheckbox]="true"
                        [toggleAllCheckboxIndeterminate]="isIndeterminateType"
                        [toggleAllCheckboxChecked]="isCheckedType" (toggleAll)="toggleSelectAllType($event)"
                        [formControl]="typeMultiFilterCtrl" [noEntriesFoundLabel]="'No se encontraron resultados'"
                        [clearSearchLabel]="'Limpiar búsqueda'"
                        [placeholderLabel]="'Buscar tipos de socios...'"></ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let type of filteredType | async" [value]="type"
                      [disabled]="isOptionDisabled(type)">{{ type.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="
                typeMultiCtrl.hasError('required') &&
                (typeMultiCtrl.dirty || typeMultiCtrl.touched)">
                    Seleccione tipos de socios de negocio
                  </mat-error>
                </mat-form-field>

                <!-- FASE 1: Campos de territorios y área de ruta removidos - se gestionan desde direcciones -->
                <!-- <mat-form-field appearance="fill" class="col-span-1">
              <mat-label>External Keys</mat-label>
              <input
                matInput
                [(ngModel)]="currentCreateBusinessPartner.externalKeys.code"
                name="external"
                required
              />
            </mat-form-field> -->
                <!-- ng-select for Compañía -->
                <!-- <div class="col-span-1">
                <label for="group-select">{{'BUSINESS_PARTNER.ROUTES' | transloco}}</label>
                <ng-select
                  [(ngModel)]="currentCreateBusinessPartner.routeIds"
                  [items]="rutaList"
                  bindLabel="name"
                  bindValue="_id"
                  [searchable]="true"
                  [multiple]="true"
                  placeholder="Seleccione rutas"
                  name="routeIds"
                  [appendTo]="'body'"
                  required
                >
                </ng-select>
              </div> -->

                <div class="col-span-1">
                  <label>{{'BUSINESS_PARTNER.SALES_OFFICE' | transloco }}</label>
                  <ng-select [(ngModel)]="currentCreateBusinessPartner.routingSalesOfficeId" [items]="salesOfficeList"
                    bindLabel="name" bindValue="_id" [searchable]="true" placeholder="Seleccione una oficina de venta"
                    [appendTo]="'body'" name="routingSalesOfficeId">
                  </ng-select>
                </div>

                <!-- ng-select for Condición de Pago -->
                <div class="col-span-1">
                  <label>{{'BUSINESS_PARTNER.PAYMENT_CONDITION' | transloco }}</label>
                  <ng-select [(ngModel)]="currentCreateBusinessPartner.paymentConditionId"
                    [items]="paymentConditionList" bindLabel="name" bindValue="_id" [searchable]="true"
                    placeholder="Condición de Pago" name="paymentConditionId" [appendTo]="'body'"
                    [required]="!isSeller">
                  </ng-select>
                </div>

                <div class="col-span-1">
                  <label>{{'BUSINESS_PARTNER.GROUP' | transloco}}</label>
                  <ng-select [(ngModel)]="currentCreateBusinessPartner.businessPartnerGroupId"
                    [items]="businessGroupList" bindLabel="name" bindValue="_id" [searchable]="true"
                    placeholder="Seleccione un grupo" [appendTo]="'body'" name="businessPartnerGroupId"
                    (ngModelChange)="changeGroup($event)">
                  </ng-select>
                </div>

                <div class="col-span-1">
                  <label>{{ 'BUSINESS_PARTNER.SUBGROUP' | transloco }}</label>
                  <ng-select [(ngModel)]="currentCreateBusinessPartner.businessPartnerSubGroupId"
                    [items]="listFilterBusinessSubGroup" bindLabel="name" bindValue="_id" [searchable]="true"
                    placeholder="Seleccione un subgrupo" name="businessPartnerSubGroupId" [appendTo]="'body'">
                    <ng-template ng-label-tmp let-item="item">
                      {{ item.name }}
                    </ng-template>
                  </ng-select>
                </div>

              <div class="col-span-1">
                  <label>{{'BUSINESS_PARTNER.ROUTE_AREA' | transloco }}</label>
                  <ng-select [(ngModel)]="currentCreateBusinessPartner.routeAreaId" [items]="routeAreaList"
                    bindLabel="name" bindValue="_id" [searchable]="true" placeholder="Seleccione una ruta"
                    name="routeAreaId" [appendTo]="'body'" required>
                  </ng-select>
              </div>

                <!-- <mat-form-field appearance="fill" class="col-span-1">
              <mat-label>Posición</mat-label>
              <input
                matInput
                [(ngModel)]="currentCreateBusinessPartner.position"
                name="position"
                type="number"
                required
              />
            </mat-form-field> -->

                <!-- ng-select for Compañía -->
                <!-- <div class="col-span-1">
                  <label for="group-select">{{'BUSINESS_PARTNER.BPTYPE' | transloco}}</label>
                  <ng-select
                    [(ngModel)]="currentCreateBusinessPartner.typeIds"
                    [items]="businessPartnerTypeList"
                    bindLabel="name"
                    bindValue="_id"
                    [searchable]="true"
                    [multiple]="true"
                    placeholder="Tipos de Socios de Negocio"
                    [appendTo]="'body'"
                    name="typeIds"
                    required
                  >
                  </ng-select>
                </div> -->
                <!-- ng-select for Compañía -->
                <!-- <div class="col-span-1">
            <label for="group-select">{{'BUSINESS_PARTNER.COMPANIES' | transloco}}</label>
            <ng-select
              [(ngModel)]="currentCreateBusinessPartner.companyIds"
              [items]="companyList"
              bindLabel="name"
              bindValue="_id"
              [searchable]="true"
              [multiple]="true"
              placeholder="Seleccione una compañía"
              [appendTo]="'body'"
              name="companyIds"
              required
            >
            </ng-select>
          </div> -->

                <mat-form-field appearance="fill" class="col-span-1">
                  <mat-label for="group-select">Requisitos</mat-label>
                  <mat-select [formControl]="requirementMultiCtrl" placeholder="Seleccione requisitos"
                    [multiple]="true">
                    <mat-option>
                      <ngx-mat-select-search [showToggleAllCheckbox]="true"
                        [toggleAllCheckboxIndeterminate]="isIndeterminateReq" [toggleAllCheckboxChecked]="isCheckedReq"
                        (toggleAll)="toggleSelectAllReq($event)" [formControl]="requirementMultiFilterCtrl"
                        [noEntriesFoundLabel]="'No se encontraron resultados'" [clearSearchLabel]="'Limpiar búsqueda'"
                        [placeholderLabel]="'Buscar requisito...'"></ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let req of filteredRequirement | async" [value]="req">
                      <span>
                        <b *ngIf="getCode(req) as code">
                          {{ code }} -
                        </b>{{ req.name }}
                      </span>

                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="fill" class="col-span-1">
                  <mat-label>{{'BUSINESS_PARTNER.CREDIT_LIMIT' | transloco}}</mat-label>
                  <input matInput type="number" [(ngModel)]="currentCreateBusinessPartner.creditLimit"
                    name="creditLimit" />
                </mat-form-field>

                <div class="col-span-1 flex items-center">
                  <span class="slide">¿{{'BUSINESS_PARTNER.CREDIT_LIMIT' | transloco}}?</span>
                  <mat-slide-toggle [(ngModel)]="currentCreateBusinessPartner.creditLimitEnabled"
                    name="creditLimitEnabled" color="primary">
                  </mat-slide-toggle>
                </div>
              </form>
            </mat-tab>
            <mat-tab label="Cloud Sales Mobile">
              <div class="bg-default rounded-lg p-4 border border-gray-200">
                <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-3">
                  <div class="flex items-start sm:items-center gap-3">
                    <mat-icon class="text-blue-600 mt-1 sm:mt-0">gps_fixed</mat-icon>
                    <div>
                      <h4 class="font-medium text-gray-800">Validación GPS</h4>
                      <p class="text-sm text-gray-600">¿Se valida el GPS para este socio?</p>
                    </div>
                  </div>
                  <mat-slide-toggle [(ngModel)]="currentCreateBusinessPartner.useGps" name="useGps" color="primary"
                    class="flex-shrink-0">
                  </mat-slide-toggle>
                </div>

                <div *ngIf="currentCreateBusinessPartner.useGps" class="pt-3 border-t border-gray-200">
                  <div class="flex flex-col sm:flex-row gap-4 mt-3">
                    <!-- Modo de validación -->
                    <mat-form-field appearance="fill" class="w-full sm:flex-1">
                      <mat-label>Modo de validación GPS</mat-label>
                      <mat-select [(ngModel)]="currentCreateBusinessPartner.useGpsMode" name="useGpsMode">
                        <mat-option *ngFor="let mode of useGpsList" [value]="mode.value">
                          {{ mode.key | transloco }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <!-- Distancia -->
                    <mat-form-field appearance="fill" class="w-full sm:flex-1">
                      <mat-label>Distancia a validar entre vendedor y cliente</mat-label>
                      <input matInput [(ngModel)]="currentCreateBusinessPartner.distanceBtwSellerAndCustomer"
                        name="distanceBtwSellerAndCustomer" type="number" min="0" required />
                      <mat-suffix>km</mat-suffix>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </mat-dialog-content>
        <mat-dialog-actions class="modal-actions flex">
          <button mat-button mat-dialog-close class="align-left">{{'GENERAL.EXIT' | transloco}}</button>
          <button mat-raised-button color="primary" [disabled]="!createForm.valid" (click)="createBusinessPartner()"
            class="justify-end">
            {{'GENERAL.SAVE' | transloco }}
          </button>
        </mat-dialog-actions>
      </ng-template>

      <!-- Modal Editar -->
      <ng-template #editModal>
        <h2 mat-dialog-title class="text-lg font-bold mb-1">{{'GENERAL.EDIT' | transloco}} -
          {{this.currentUpdateBusinessPartner.name}}</h2>
        <mat-dialog-content class="modal-content">
          <mat-tab-group [(selectedIndex)]="selectedTabIndex">
            <mat-tab label="Datos Generales">
              <form #editForm="ngForm" class="grid grid-cols-2 gap-4">
                <mat-form-field appearance="fill" class="col-span-1">
                  <mat-label>Código Externo</mat-label>
                  <input matInput [(ngModel)]="currentUpdateBusinessPartner.externalKeys.code" name="code" disabled />
                </mat-form-field>
                <!-- Nombre -->
                <mat-form-field appearance="fill" class="col-span-1">
                  <mat-label>{{'BUSINESS_PARTNER.NAME' | transloco}}</mat-label>
                  <input matInput [(ngModel)]="currentUpdateBusinessPartner.name" name="name" required />
                </mat-form-field>

                <mat-form-field appearance="fill" class="col-span-1">
                  <mat-label>Nombre Comercial</mat-label>
                  <input matInput [(ngModel)]="currentUpdateBusinessPartner.commercialName" name="commercialName" />
                </mat-form-field>

                <mat-form-field appearance="fill" class="col-span-1">
                  <mat-label>RTN</mat-label>
                  <input matInput [(ngModel)]="currentUpdateBusinessPartner.NIT" name="NIT" [required]="isRtnRequired" />
                </mat-form-field>

                <mat-form-field appearance="fill" class="col-span-1">
                  <mat-label>DNI</mat-label>
                  <input matInput [(ngModel)]="currentUpdateBusinessPartner.DNI" name="DNI" />
                </mat-form-field>

                <mat-form-field appearance="fill" class="col-span-1">
                  <mat-label for="group-select">{{'BUSINESS_PARTNER.COMPANIES' | transloco}}</mat-label>
                  <mat-select [formControl]="companyMultiCtrl" placeholder="Seleccione una compañía" [multiple]="true">
                    <mat-option>
                      <ngx-mat-select-search [showToggleAllCheckbox]="true"
                        [toggleAllCheckboxIndeterminate]="isIndeterminateComp"
                        [toggleAllCheckboxChecked]="isCheckedComp" (toggleAll)="toggleSelectAllCompany($event)"
                        [formControl]="companyMultiFilterCtrl" [noEntriesFoundLabel]="'No se encontraron resultados'"
                        [clearSearchLabel]="'Limpiar búsqueda'"
                        [placeholderLabel]="'Buscar compañía...'"></ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let company of filteredCompany | async" [value]="company">
                      <b *ngIf="getCode(company) as code">
                        {{ code }} -
                      </b>
                      {{ company.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="
                  companyMultiCtrl.hasError('required') &&
                  (companyMultiCtrl.dirty || companyMultiCtrl.touched)
                  ">
                    Seleccione una compañía
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" class="col-span-1">
                  <mat-label for="group-select">{{'BUSINESS_PARTNER.BPTYPE' | transloco}}</mat-label>
                  <mat-select [formControl]="typeMultiCtrl" placeholder="Seleccione tipos de socios de negocio"
                    [multiple]="true" (selectionChange)="onTypeChange($event)">
                    <mat-option>
                      <ngx-mat-select-search [showToggleAllCheckbox]="true"
                        [toggleAllCheckboxIndeterminate]="isIndeterminateType"
                        [toggleAllCheckboxChecked]="isCheckedType" (toggleAll)="toggleSelectAllType($event)"
                        [formControl]="typeMultiFilterCtrl" [noEntriesFoundLabel]="'No se encontraron resultados'"
                        [clearSearchLabel]="'Limpiar búsqueda'"
                        [placeholderLabel]="'Buscar tipos de socios...'"></ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let type of filteredType | async" [value]="type"
                      [disabled]="isOptionDisabled(type)">{{ type.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="
                  typeMultiCtrl.hasError('required') &&
                  (typeMultiCtrl.dirty || typeMultiCtrl.touched)
                  ">
                    Seleccione tipos de socios de negocio
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" class="col-span-1">
                  <mat-label for="group-select">{{'BUSINESS_PARTNER.ROUTES' | transloco}}</mat-label>
                  <mat-select [formControl]="routeMultiCtrl" placeholder="Territorios asociados" [multiple]="true">
                    <mat-option>
                      <ngx-mat-select-search [showToggleAllCheckbox]="false"
                        [formControl]="routeMultiFilterCtrl"
                        [noEntriesFoundLabel]="'No se encontraron resultados'" [clearSearchLabel]="'Limpiar búsqueda'"
                        [placeholderLabel]="'Buscar territorio...'" [disabled]="true"></ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let route of filteredRoutes | async" [value]="route" class="territory-readonly-option">
                      <div class="route-option-container w-full">
                        <span class="flex items-center gap-2">
                          <span>
                            <b *ngIf="getCode(route) as code">{{ code }} -</b>
                            {{ route.name }}
                          </span>
                        </span>

                        <div>
                          <mat-slide-toggle
                            (click)="$event.stopPropagation()"
                            color="primary"
                            [checked]="route.isPrincipal"
                            (change)="togglePrincipalTerritory(route, $event)">
                            <span>Principal</span>
                          </mat-slide-toggle>
                        </div>
                      </div>
                    </mat-option>
                  </mat-select>
                  <mat-hint *ngIf="!hasPrincipalTerritory()" class="flex items-center gap-1 text-orange-500">
                    <mat-icon class="text-sm">warning</mat-icon>
                    <span>Ningún territorio está marcado como principal. Por favor, seleccione uno.</span>
                  </mat-hint>
                </mat-form-field>

                <div class="col-span-1">
                  <label>{{'BUSINESS_PARTNER.ROUTE_AREA' | transloco}}</label>
                  <ng-select [(ngModel)]="currentUpdateBusinessPartner.routeArea" [items]="routeAreaList"
                    bindLabel="name" bindValue="_id" [searchable]="true" placeholder="Área de ruta"
                    name="routeAreaId" [compareWith]="compareById"
                    [appendTo]="'body'" ></ng-select>
                </div>

                <div class="col-span-1">
                  <label>{{'BUSINESS_PARTNER.SALES_OFFICE' | transloco }}</label>
                  <ng-select [(ngModel)]="currentUpdateBusinessPartner.routingSalesOffice" [items]="salesOfficeList"
                    bindLabel="name" bindValue="_id" [searchable]="true" placeholder="Seleccione una sala de oficina"
                    name="routingSalesOfficeId" [compareWith]="compareById"
                    (ngModelChange)="onSalesOfficeSelectionChange($event)" [appendTo]="'body'">
                  </ng-select>
                </div>

                <div class="col-span-1">
                  <label for="group-select">{{'BUSINESS_PARTNER.PAYMENT_CONDITION' | transloco}}</label>
                  <ng-select [(ngModel)]="currentUpdateBusinessPartner.paymentCondition" [items]="paymentConditionList"
                    bindLabel="name" bindValue="_id" [searchable]="true" placeholder="Seleccione condición de pago"
                    name="paymentConditionId" [compareWith]="compareById"
                    (ngModelChange)="onPaymentConditionSelectionChange($event)" [appendTo]="'body'"
                    [required]="!isSeller"></ng-select>
                </div>

                <div class="col-span-1">
                  <label>{{'BUSINESS_PARTNER.GROUP' | transloco}}</label>
                  <ng-select [(ngModel)]="currentUpdateBusinessPartner.businessPartnerGroup" [items]="businessGroupList"
                    bindLabel="name" bindValue="_id" [searchable]="true" placeholder="Seleccione un grupo de socio"
                    name="businessPartnerGroupId" [compareWith]="compareById"
                    (ngModelChange)="onBusinessGroupSelectionChange($event); changeGroup($event)" [appendTo]="'body'">
                  </ng-select>
                </div>

                <div class="col-span-1">
                  <label>{{ 'BUSINESS_PARTNER.SUBGROUP' | transloco }}</label>
                  <ng-select [(ngModel)]="currentUpdateBusinessPartner.businessPartnerSubGroup"
                    [items]="listFilterBusinessSubGroup" bindLabel="name" bindValue="_id" [searchable]="true"
                    placeholder="Seleccione un subgrupo" name="businessPartnerSubGroup" [compareWith]="compareById"
                    (ngModelChange)="onBusinessSubGroupSelectionChange($event)" [appendTo]="'body'">
                    <ng-template ng-label-tmp let-item="item">
                      {{ item.name }}
                    </ng-template>
                  </ng-select>
                </div>

                <mat-form-field appearance="fill" class="col-span-1">
                  <mat-label for="group-select">Requisitos</mat-label>
                  <mat-select [formControl]="requirementMultiCtrl" placeholder="Seleccione requisitos"
                    [multiple]="true">
                    <mat-option>
                      <ngx-mat-select-search [showToggleAllCheckbox]="true"
                        [toggleAllCheckboxIndeterminate]="isIndeterminateReq" [toggleAllCheckboxChecked]="isCheckedReq"
                        (toggleAll)="toggleSelectAllReq($event)" [formControl]="requirementMultiFilterCtrl"
                        [noEntriesFoundLabel]="'No se encontraron resultados'" [clearSearchLabel]="'Limpiar búsqueda'"
                        [placeholderLabel]="'Buscar requisito...'"></ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let req of filteredRequirement | async" [value]="req">
                      <span>
                        <b *ngIf="getCode(req) as code">
                          {{ code }} -
                        </b>{{ req.name }}
                      </span>

                    </mat-option>
                  </mat-select>
                </mat-form-field>


                <!-- Código -->
                <mat-form-field appearance="fill" class="col-span-1">
                  <mat-label>{{'BUSINESS_PARTNER.CREDIT_LIMIT' | transloco}}</mat-label>
                  <input matInput type="number" [(ngModel)]="currentUpdateBusinessPartner.creditLimit"
                    name="creditLimit" />
                </mat-form-field>

                <div class="col-span-1 flex items-center">
                  <span class="slide">¿{{'BUSINESS_PARTNER.CREDIT_LIMIT' | transloco}}?</span>
                  <mat-slide-toggle [(ngModel)]="currentUpdateBusinessPartner.creditLimitEnabled"
                    name="creditLimitEnabled" color="primary">
                  </mat-slide-toggle>
                </div>                
              </form>
            </mat-tab>
            <mat-tab [label]="'DISTRIBUTION_CHAIN' | transloco">
              <div class="table-container">
                <table mat-table [dataSource]="currentUpdateBusinessPartner.distributionChains">
                  <!-- Define columns here -->
                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef> {{'BUSINESS_PARTNER.NAME' | transloco}} </th>
                    <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                  </ng-container>
                  <ng-container matColumnDef="channel">
                    <th mat-header-cell *matHeaderCellDef> {{'CHANNEL' | transloco}} </th>
                    <td mat-cell *matCellDef="let element"> {{element.channel.name}} </td>
                  </ng-container>
                  <!-- Estado (mat-slide-toggle) -->
                  <ng-container matColumnDef="statusId">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                      Estado
                    </th>
                    <td mat-cell *matCellDef="let element" class="px-6 text-left">
                      <mat-slide-toggle [checked]="element.statusId === 1"
                        (change)="onStatusChangeChain($event.checked, element)" color="primary">
                      </mat-slide-toggle>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>
                      <button color="primary" mat-button (click)="openDistributionChainModal()"
                        [matTooltip]="'DISTRIBUTION.CREATE' | transloco ">
                        <mat-icon svgIcon="heroicons_solid:plus"></mat-icon>
                      </button>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <div class="button-container">
                        <button mat-icon-button (click)="openDistributionChainModal(element)"
                          matTooltip="Editar Registro">
                          <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                        </button>
                        <button mat-icon-button (click)="enableInterlocutorTab(element)"
                          matTooltip="Agregar Interlocutor">
                          <mat-icon svgIcon="heroicons_outline:user-plus"></mat-icon>
                        </button>
                        <button mat-icon-button (click)="openDeleteChain(element)" matTooltip="Eliminar Registro">
                          <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                        </button>
                      </div>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumnsChain"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsChain;"></tr>
                </table>
              </div>
            </mat-tab>
            <mat-tab label="Interlocutor" *ngIf="isInterlocutorTabVisible" [disabled]="!isInterlocutorTabEnabled">
              <div class="table-container">
                <table mat-table [dataSource]="interlocutorsDataSource">
                  <!-- Define columns here -->
                  <ng-container matColumnDef="code">
                    <th mat-header-cell *matHeaderCellDef> Código </th>
                    <td mat-cell *matCellDef="let element"> {{element?.businessPartner?.externalKeys?.code}} </td>
                  </ng-container>
                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef> Nombre </th>
                    <td mat-cell *matCellDef="let element"> {{element?.businessPartner?.name}} </td>
                  </ng-container>
                  <ng-container matColumnDef="function">
                    <th mat-header-cell *matHeaderCellDef> Función </th>
                    <td mat-cell *matCellDef="let element"> {{element.businessPartnerFunctions[0]?.name}} </td>
                  </ng-container>
                  <!-- Estado (mat-slide-toggle) -->
                  <ng-container matColumnDef="statusId">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                      Estado
                    </th>
                    <td mat-cell *matCellDef="let element" class="px-6 text-left">
                      <mat-slide-toggle [checked]="element.statusId === 1"
                        (change)="onStatusChangeInterlocutor($event.checked, element)" color="primary">
                      </mat-slide-toggle>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>
                      <button color="primary" mat-button (click)="openInterlocutorModal()"
                        matTooltip="Agregar Interlocutor">
                        <mat-icon svgIcon="heroicons_solid:plus"></mat-icon>
                        <span></span>
                      </button>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <div class="button-container">
                        <button mat-icon-button (click)="openInterlocutorModal(element)" matTooltip="Editar Registro">
                          <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                        </button>
                        <button mat-icon-button (click)="openDeleteInterlocutor(element)"
                          matTooltip="Eliminar Registro">
                          <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                        </button>
                      </div>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumnsEditInterlocutor"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsEditInterlocutor;"></tr>
                </table>
              </div>
            </mat-tab>
            <mat-tab label="Contactos">
              <div class="table-container">
                <table mat-table [dataSource]="currentUpdateBusinessPartner.contacts">
                  <!-- Define columns here -->
                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef> Nombre </th>
                    <td mat-cell *matCellDef="let element"> {{element.contact.firstName}} </td>
                  </ng-container>
                  <ng-container matColumnDef="lastName">
                    <th mat-header-cell *matHeaderCellDef> Apellido </th>
                    <td mat-cell *matCellDef="let element"> {{element.contact.lastName}} </td>
                  </ng-container>
                  <!-- Estado (mat-slide-toggle) -->
                  <ng-container matColumnDef="statusId">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                      Estado
                    </th>
                    <td mat-cell *matCellDef="let element" class="px-6 text-left">
                      <mat-slide-toggle [checked]="element.contact.statusId === 1"
                        (change)="onStatusChangeContact($event.checked, element)" color="primary">
                      </mat-slide-toggle>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>
                      <button color="primary" mat-button (click)="openContactModal()" matTooltip="Agregar Contacto">
                        <mat-icon svgIcon="heroicons_solid:plus"></mat-icon>
                      </button>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <div class="button-container">
                        <button mat-icon-button (click)="openContactModal(element)" matTooltip="Editar Registro">
                          <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                        </button>
                        <button mat-icon-button (click)="openDeleteContact(element)" matTooltip="Eliminar Registro">
                          <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                        </button>
                      </div>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumnsContact"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsContact;"></tr>
                </table>
              </div>
            </mat-tab>
            <mat-tab label="Direcciones">
              <div class="table-container">
                <table mat-table [dataSource]="currentUpdateBusinessPartner.addresses">
                  <!-- Define columns here -->
                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef> Nombre</th>
                    <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                  </ng-container>
                  <ng-container matColumnDef="address">
                    <th mat-header-cell *matHeaderCellDef> Dirección </th>
                    <td mat-cell *matCellDef="let element"> {{element.address}} </td>
                  </ng-container>
                  <ng-container matColumnDef="statusId">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                      Estado
                    </th>
                    <td mat-cell *matCellDef="let element" class="px-6 text-left">
                      <mat-slide-toggle [checked]="element.statusId === 1"
                        (change)="onStatusChangeAddress($event.checked, element)" color="primary">
                      </mat-slide-toggle>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="geolocationPoint">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                      ¿Repinear Cliente?
                    </th>
                    <td mat-cell *matCellDef="let element" class="px-6 text-left">
                      <mat-slide-toggle
                        [disabled]="currentUpdateBusinessPartner?.subRouteThereAreFrequencies?.length===0 || !currentUpdateBusinessPartner.subRouteThereAreFrequencies"
                        [checked]="element.geolocationPointUpdate === true"
                        (change)="onUpdateGeo($event.checked, element)" color="primary">
                      </mat-slide-toggle>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>
                      <div class="flex">
                        <button color="primary" mat-button (click)="openAddressModal()" matTooltip="Agregar Dirección">
                          <mat-icon svgIcon="heroicons_solid:plus"></mat-icon>
                        </button>
                        <button mat-stroked-button color="primary" (click)="downloadReportBpExcel()"
                          matTooltip="Exportar">
                          <mat-icon class="text-current" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
                        </button>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <div class="button-container">
                        <button mat-icon-button (click)="openAddressModal(element)" matTooltip="Editar Registro">
                          <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                        </button>
                        <button mat-icon-button (click)="openDeleteAddress(element)" matTooltip="Eliminar Registro">
                          <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                        </button>
                      </div>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumnsAddress"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsAddress;"></tr>
                </table>
              </div>
            </mat-tab>
            <mat-tab label="Teléfonos">
              <div class="table-container">
                <table mat-table [dataSource]="currentUpdateBusinessPartner.phones">
                  <!-- Define columns here -->
                  <ng-container matColumnDef="prefix">
                    <th mat-header-cell *matHeaderCellDef> Número Teléfonico </th>
                    <td mat-cell *matCellDef="let phone"> {{phone.prefix}} {{phone.phone}} </td>
                  </ng-container>
                  <!-- Estado (mat-slide-toggle) -->
                  <ng-container matColumnDef="statusId">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                      Estado
                    </th>
                    <td mat-cell *matCellDef="let phone" class="px-6 text-left">
                      <mat-slide-toggle [checked]="phone.statusId === 1"
                        (change)="onStatusChangePhone($event.checked, phone)" color="primary">
                      </mat-slide-toggle>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>
                      <button color="primary" mat-button (click)="openPhoneModal()" matTooltip="Agregar Teléfono">
                        <mat-icon svgIcon="heroicons_solid:plus"></mat-icon>
                        <span></span>
                      </button>
                    </th>
                    <td mat-cell *matCellDef="let phone">
                      <div class="button-container">
                        <button mat-icon-button (click)="openPhoneModal(phone)" matTooltip="Editar Registro">
                          <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                        </button>
                        <button mat-icon-button (click)="openDeletePhone(phone)" matTooltip="Eliminar Registro">
                          <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                        </button>
                      </div>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumnsPhone"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsPhone;"></tr>
                </table>
              </div>
              <div class="table-container">
                <!-- Email -->
                <h2 style="padding: 10px;"></h2>
                <table mat-table [dataSource]="currentUpdateBusinessPartner.emails">
                  <!-- Define columns here -->
                  <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef> Correo Electrónico </th>
                    <td mat-cell *matCellDef="let email"> {{email.email}} </td>
                  </ng-container>
                  <!-- Estado (mat-slide-toggle) -->
                  <ng-container matColumnDef="statusId">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                      Estado
                    </th>
                    <td mat-cell *matCellDef="let email" class="px-6 text-left">
                      <mat-slide-toggle [checked]="email.statusId === 1"
                        (change)="onStatusChangeEmail($event.checked, email)" color="primary">
                      </mat-slide-toggle>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>
                      <button color="primary" mat-button (click)="openEmailModal()" matTooltip="Agregar Correo">
                        <mat-icon svgIcon="heroicons_solid:plus"></mat-icon>
                        <span></span>
                      </button>
                    </th>
                    <td mat-cell *matCellDef="let email">
                      <div class="button-container">
                        <button mat-icon-button (click)="openEmailModal(email)" matTooltip="Editar Registro">
                          <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                        </button>
                        <button mat-icon-button (click)="openDeleteEmail(email)" matTooltip="Eliminar Registro">
                          <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                        </button>
                      </div>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumnsEmail"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsEmail;"></tr>
                </table>
              </div>
            </mat-tab>
            <mat-tab label="Campos de usuario" *ngIf="fieldsMasterDataStatus">
              <app-user-fields-configuration [fields]="fieldsMasterData" [model]="currentUpdateBusinessPartner"></app-user-fields-configuration>
            </mat-tab>
            <mat-tab label="V.Ho.de Entrega">
              <div class="table-container">
                <table mat-table [dataSource]="currentUpdateBusinessPartner.orderDeliveryWindows">
                  <!-- Define columns here -->
                  <ng-container matColumnDef="days">
                    <th mat-header-cell *matHeaderCellDef> Días</th>
                    <td mat-cell *matCellDef="let element"> {{ getDayNames(element.days) || "N/A" }}</td>
                  </ng-container>
                  <ng-container matColumnDef="hourStart">
                    <th mat-header-cell *matHeaderCellDef> Hora de Inicio </th>
                    <td mat-cell *matCellDef="let element"> {{element.hourStart}} </td>
                  </ng-container>
                  <ng-container matColumnDef="hourEnd">
                    <th mat-header-cell *matHeaderCellDef> Hora Fin </th>
                    <td mat-cell *matCellDef="let element"> {{element.hourEnd}} </td>
                  </ng-container>
                  <!-- Estado (mat-slide-toggle) -->
                  <ng-container matColumnDef="statusId">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                      Estado
                    </th>
                    <td mat-cell *matCellDef="let element" class="px-6 text-left">
                      <mat-slide-toggle [checked]="element.statusId === 1"
                        (change)="onStatusChangeOrder($event.checked, element)" color="primary">
                      </mat-slide-toggle>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>
                      <button color="primary" mat-button (click)="openOrderModal()" matTooltip="Nuevo registro">
                        <mat-icon svgIcon="heroicons_solid:plus"></mat-icon>
                        <span></span>
                      </button>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <div class="button-container">

                        <button mat-icon-button (click)="openOrderModal(element)" matTooltip="Editar Registro">
                          <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                        </button>
                        <button mat-icon-button (click)="openDeleteOrder(element)" matTooltip="Eliminar Registro">
                          <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                        </button>
                      </div>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumnsOrder"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsOrder;"></tr>
                </table>
              </div>
            </mat-tab>
            <mat-tab label="Grupo de Material">
              <form #mgForm="ngForm" class="grid grid-cols-1 gap-4">
                <mat-form-field appearance="fill" class="w-full">
                  <mat-label>Grupo de Material</mat-label>
                  <mat-select [(ngModel)]="currentUpdateBusinessPartner.materialGroupIds" name="materialGroupIds"
                    multiple required>
                    <mat-option>
                      <ngx-mat-select-search [(ngModel)]="searchMaterialGroup" [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="
                      isProjectTree
                        ? filterTree($event)
                        : changueOptionsGroupMaterial($event)
                    " placeholderLabel="Buscar..." noEntriesFoundLabel="No se encontraron resultados">
                      </ngx-mat-select-search>
                    </mat-option>

                    @if (!isProjectTree) {
                    @for (group of listCategories; track group) {
                    <mat-option [value]="group.code">
                      <b>{{ group.code }}</b> - {{ group.name }}
                    </mat-option>
                    }
                    } @else {
                    <mat-optgroup *ngFor="let group of listCategories" [label]="group.name">
                      <mat-option *ngFor="let subgroup of group.children" [value]="subgroup.code">
                        <ng-container *ngIf="getCode(subgroup) as code">
                          <b class="f-12">{{ code }}</b> -
                        </ng-container>
                        {{ subgroup.name }}
                      </mat-option>
                    </mat-optgroup>
                    }
                  </mat-select>
                </mat-form-field>
              </form>

            </mat-tab>
            <mat-tab label="Cloud Sales Mobile">
              <div class="bg-default rounded-lg p-4 border border-gray-200">
                <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-3">
                  <div class="flex items-start sm:items-center gap-3">
                    <mat-icon class="text-blue-600 mt-1 sm:mt-0">gps_fixed</mat-icon>
                    <div>
                      <h4 class="font-medium text-gray-800">Validación GPS</h4>
                      <p class="text-sm text-gray-600">¿Se valida el GPS para este socio?</p>
                    </div>
                  </div>
                  <mat-slide-toggle [(ngModel)]="currentUpdateBusinessPartner.useGps" name="useGps" color="primary"
                    class="flex-shrink-0">
                  </mat-slide-toggle>
                </div>

                <div *ngIf="currentUpdateBusinessPartner.useGps" class="pt-3 border-t border-gray-200">
                  <div class="flex flex-col sm:flex-row gap-4 mt-3">
                    <!-- Modo de validación -->
                    <mat-form-field appearance="fill" class="w-full sm:flex-1">
                      <mat-label>Modo de validación GPS</mat-label>
                      <mat-select [(ngModel)]="currentUpdateBusinessPartner.useGpsMode" name="useGpsMode">
                        <mat-option *ngFor="let mode of useGpsList" [value]="mode.value">
                          {{ mode.key | transloco }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <!-- Distancia -->
                    <mat-form-field appearance="fill" class="w-full sm:flex-1">
                      <mat-label>Distancia a validar entre vendedor y cliente</mat-label>
                      <input matInput [(ngModel)]="currentUpdateBusinessPartner.distanceBtwSellerAndCustomer"
                        name="distanceBtwSellerAndCustomer" type="number" min="0" required />
                      <mat-suffix>km</mat-suffix>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </mat-tab>

          </mat-tab-group>
        </mat-dialog-content>
        <mat-dialog-actions class="modal-actions flex">
          <button mat-button mat-dialog-close class="align-left">Cancelar</button>
          <button mat-raised-button color="primary" (click)="updateBusinessPartner(currentUpdateBusinessPartner._id)"
            [disabled]="!editForm.valid">
            Guardar
          </button>
        </mat-dialog-actions>
      </ng-template>


      <!-- Modal Eliminar -->
      <ng-template #deleteDialog let-data>
        <div class="flex items-start space-x-2 mb-4">
          <div class="flex items-center">
            <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
              style="font-size: 32px"></mat-icon>
          </div>
          <div class="grid">
            <h2 mat-dialog-title class="text-lg font-bold mb-1">
              Confirmar eliminación
            </h2>
            <mat-dialog-content class="modal-content mt-0">
              <p>¿Está seguro que desea eliminar el registro?</p>
            </mat-dialog-content>
          </div>
        </div>
        <mat-dialog-actions class="modal-actions flex justify-end">
          <button mat-button mat-dialog-close class="align-left">
            Conservar
          </button>
          <button mat-raised-button color="warn" [mat-dialog-close]="true">
            Eliminar
          </button>
        </mat-dialog-actions>
      </ng-template>
    </div>

    <ng-template #routesModal>
      <app-routes-detail-by-business-partner-vehicle [parameterId]="businessParnerIdSelected"
        [typeModal]="'businessPartner'" [showTablePrincipal]="false"
        [showSubRoutes]="true"></app-routes-detail-by-business-partner-vehicle>
    </ng-template>

    <ng-template #tripsModal>
      <app-routes-detail-by-business-partner-vehicle [parameterId]="businessParnerIdSelected"
        [typeModal]="'businessPartner'" [showTablePrincipal]="false"
        [showTrips]="true"></app-routes-detail-by-business-partner-vehicle>
    </ng-template>
  </div>


  <!-- Filtros -->
  <app-filter (onFilterEvent)="findAllWithCount()" (onCleanEvent)="clearFilters()" (onPanelOpened)="onFilterPanelOpened()">
    <app-configuration-filters [form]="form" [company]="true" [loadData]="loadFiltersData"></app-configuration-filters>
    <app-business-partners-filters [form]="form" [businessPartnerRolList]="rolList" [loadData]="loadFiltersData"></app-business-partners-filters>
    <app-routes-filters [form]="form" [route]="true" [loadData]="loadFiltersData"></app-routes-filters>
  </app-filter>


</mat-sidenav-container>